import { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import PersonIcon from "@material-ui/icons/Person";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import AppsIcon from "@material-ui/icons/Apps";
import PrintIcon from "@material-ui/icons/Print";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import { signOut } from "../services/api/AuthService";
import * as PlansServices from "../services/api/PlansServices";
import * as ProfessionalsServices from "../services/api/ProfessionalsServices";
import imgAp from "../assets/img/imgLogin.jpg";

const useStyles = makeStyles({
  sidebar: {
    backgroundColor: "#fff",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.06)",
    padding: "22px 14px",
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  profileHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "8px 12px 20px",
    borderBottom: "1px solid #eef0f2",
    marginBottom: 12,
  },
  avatar: {
    width: 76,
    height: 76,
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #eef6f9",
    marginBottom: 10,
  },
  accountName: {
    color: "#2b2f36",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.2,
  },
  accountRole: {
    color: "#9aa0a6",
    fontFamily: "Montserrat",
    fontSize: 12,
    fontWeight: 500,
    marginTop: 2,
  },
  sectionLabel: {
    color: "#b0b6bd",
    fontFamily: "Montserrat",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.08em",
    padding: "4px 16px 8px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderRadius: 10,
    color: "#5a6472",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    textDecoration: "none",
    transition: "all 0.18s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#eef6f9",
      color: "#54B5CF",
      textDecoration: "none",
    },
  },
  navItemActive: {
    backgroundColor: "#54B5CF",
    color: "#fff",
    boxShadow: "0 6px 16px rgba(84, 181, 207, 0.35)",
    "&:hover": {
      backgroundColor: "#54B5CF",
      color: "#fff",
    },
  },
  icon: {
    fontSize: 20,
  },
  logout: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    marginTop: 12,
    borderTop: "1px solid #eef0f2",
    paddingTop: 16,
    border: "none",
    background: "none",
    width: "100%",
    color: "#e06464",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    borderRadius: 10,
    transition: "all 0.18s ease",
    "&:hover": {
      backgroundColor: "#fdeeee",
    },
  },
});

export default function MenuPerfil() {
  const classes = useStyles();
  const history = useHistory();
  const [plan, setPlan] = useState(null);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const resp = await PlansServices.get();
        setPlan(resp.data[0]);
      } catch (error) {
        // silencioso
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const resp = await ProfessionalsServices.getProfile();
        setProfile(resp.data);
      } catch (error) {
        // silencioso
      }
    })();
  }, []);

  const handleSignOut = async (e) => {
    e.preventDefault();
    await signOut();
    history.push("/admin/dashboard/login");
  };

  const subscriberRoute = (route) =>
    plan?.plans_id !== null && plan ? route : "/admin/profissional/assinatura";

  return (
    <div className={classes.sidebar}>
      <div className={classes.profileHeader}>
        <img
          src={profile?.picture || imgAp}
          alt="Foto do perfil"
          className={classes.avatar}
        />
        <Typography className={classes.accountName}>
          {profile?.name || "Minha Conta"}
        </Typography>
        {profile?.formation && (
          <Typography className={classes.accountRole}>
            {profile.formation}
          </Typography>
        )}
      </div>

      <div className={classes.sectionLabel}>MINHA CONTA</div>

      <NavLink
        exact
        className={classes.navItem}
        activeClassName={classes.navItemActive}
        to="/admin/profissional/perfil"
      >
        <PersonIcon className={classes.icon} />
        Perfil
      </NavLink>

      <NavLink
        className={classes.navItem}
        activeClassName={classes.navItemActive}
        to="/admin/profissional/assinatura"
      >
        <CardMembershipIcon className={classes.icon} />
        Assinatura
      </NavLink>

      <NavLink
        className={classes.navItem}
        activeClassName={classes.navItemActive}
        to="/profissionais-supervisor"
      >
        <SupervisorAccountIcon className={classes.icon} />
        Supervisores
      </NavLink>

      {profile?.cpf_cnpj && (
        <>
          <div className={classes.sectionLabel}>PRÓ-FONO</div>

          <NavLink
            className={classes.navItem}
            activeClassName={classes.navItemActive}
            to={subscriberRoute("/apps")}
          >
            <AppsIcon className={classes.icon} />
            Apps Pró-Fono
          </NavLink>

          <NavLink
            className={classes.navItem}
            activeClassName={classes.navItemActive}
            to={subscriberRoute("/imprimir")}
          >
            <PrintIcon className={classes.icon} />
            Imprimir e Praticar
          </NavLink>

          <NavLink
            className={classes.navItem}
            activeClassName={classes.navItemActive}
            to={subscriberRoute("/admin/profissional/books")}
          >
            <MenuBookIcon className={classes.icon} />
            Ebooks Pró-Fono
          </NavLink>

          <NavLink
            className={classes.navItem}
            activeClassName={classes.navItemActive}
            to={subscriberRoute("/playlists")}
          >
            <OndemandVideoIcon className={classes.icon} />
            Vídeos Pró-Fono
          </NavLink>
        </>
      )}

      <button className={classes.logout} onClick={handleSignOut}>
        <ExitToAppIcon className={classes.icon} />
        Sair
      </button>
    </div>
  );
}
